import { hasLength } from '../../../utils/dataTransformations';
import {
  ADMIN_LDAP_GROUP,
  AUDITOR_LDAP_GROUP,
  ENGINEER_LDAP_GROUP,
  GENERAL_USER_LDAP_GROUP,
} from '../../../types/constants';

const LDAP_GROUP_LABELS: Record<string, string> = {
  [GENERAL_USER_LDAP_GROUP]: 'Regular user',
  [AUDITOR_LDAP_GROUP]: 'Auditor',
  [ADMIN_LDAP_GROUP]: 'Admin',
  [ENGINEER_LDAP_GROUP]: 'Engineer',
};

export const ldapGroupToLabel = (group: string): string => LDAP_GROUP_LABELS[group] ?? group;

export const simulatedLdapToBannerTitle = (simulatedLdap: string[]): string =>
  `Viewing Navigator as ${simulatedLdap.join(', ')}`;

/** Simulation can only start once at least one group is selected; exiting is always allowed. */
export const selectionToIsToggleDisabled =
  (checked: boolean) =>
  (selected: string[]): boolean =>
    !checked && !hasLength(selected);

export interface SelectOptionData {
  id: string;
  value: string;
  label: string;
}

export const ldapGroupToSelectOption = (group: string): SelectOptionData => ({
  value: group,
  label: ldapGroupToLabel(group),
  id: group,
});

/** Replaces Meridian's default "2 selected" with the names of the selected options. */
export const selectedOptionsToValueLabel = (selectedOptions: { label: string }[]): string =>
  selectedOptions.map(({ label }) => label).join(', ');
